import React,{useContext} from "react";

//mui
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@mui/material/Popper";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import { AlertContext } from "contexts/AlertContext";

const StyledPopper = styled(Popper)(({ theme }) => ({
  "& .MuiAutocomplete-listbox": {
    "& li": {
      fontSize: "15px",
      [theme.breakpoints.down("xl")]: {
        fontSize: "13px",
      },
    },
  },
}));

const Container = styled("div")(({ theme }) => ({
  width:"100%",
  "& .MuiMenuItem-root": {
    // background: "green",
  },
  "& .MuiAutocomplete-root": {
    background: "#FFFFFF",
  },
  "& .MuiAutocomplete-input": {
    height: "19px",
    fontSize: "14px",
    [theme.breakpoints.down("xl")]: {
      height: "17px",
      fontSize: "14px",
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "15px",
    color: "#4F4F4F",
    [theme.breakpoints.down("xl")]: {
      fontSize: "14px",
    },
  },
}));

const CustomPopper = (props) => {
  return <StyledPopper {...props} placement="bottom" />;
};
 
const AutoCompleteState = ({
  value,
  options,
  variant = "outlined",
  disabled = false,
  onChange,
  label,
  textColor,
  text,
  multiple=false,
  enableCheckbox=false,
  disableClear = false,
  disableCloseOnSelect = false,
  type="",
  maxTagLimit=false,
  ...restProps
}) => {

  const MAX_TAGS = 3;
  const { showAlert } = useContext(AlertContext);
  let newVal = [
    {
      id: "",
      name: "",
    }
  ];
  if (value && typeof value === "string") {
    newVal = options.filter((item) => item.name === value);
    if (newVal.length === 0) {
      newVal = [
        {
          id: "",
          name: "",
        },
      ];
    }
  } else if (value?.name === "" && typeof value?.id === "number") {
    newVal = options.filter((item) => item?.id === value?.id);
  } else if (value) {
    newVal = [value];
  }
  return (
    <Container>
      <FormControl variant="outlined" style={{ width: "100%", padding: 0 }}>
        <Autocomplete
          fullWidth
          value={value}
          multiple={multiple}
          options={options}
          disableCloseOnSelect={disableCloseOnSelect}
          limitTags={2}
          renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              {enableCheckbox && <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />}
              {option.name}
            </li>
          );
        }}
          renderTags={(value) => {
          if (!value || value.length === 0) return null;

          return (
            <span style={{ paddingLeft: 2 , fontSize: 14 ,textAlign:"center"}}>
              {value.length} tag{value.length > 1 ? "s" : ""} selected
            </span>
          );}}
          disableClearable={disableClear}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          getOptionLabel={(option) => (option ? `${option?.name}` : "")}
          onChange={(event, newValue) => {
            // TAG-specific logic
            if (type === "tag") {
              // when cleared
              if (newValue===null) {
                onChange(null, text);
                return;
              }

              // enforce max tag limit
              if (maxTagLimit && Array.isArray(newValue) && newValue.length > MAX_TAGS) {
                showAlert("You cannot select more than 3 tags", "error");
                return;
              }
            }

            // default behavior
            onChange(newValue, text);
          }}

          filterSelectedOptions={type !== "tag"}          
          renderInput={(params, index) => {
            
            const { InputProps, inputProps, ...renderProps } = params;
            inputProps.disabled = disabled;
            InputProps.endAdornment = disabled ? (
              <></>
            ) : (
              InputProps.endAdornment
            );
            return (
              <TextField
                key={index}
                {...renderProps}
                InputProps={{
                  ...InputProps,
                  disableUnderline: variant === "standard" ? true : false,
                }}
                sx={{ input: { color: `${textColor}` } }}
                inputProps={inputProps}
                label={label}
                // className={classes.input}
                variant={variant}
                {...restProps}
              />
            );
          }}
          
          PopperComponent={CustomPopper}
        />
      </FormControl>
    </Container>
  );
};

export default AutoCompleteState;
